import React from 'react'

import { Box, Typography } from "@mui/material"


export default function reportNameColumn() {

	return {
		name: 'name',
		label: 'Report name',
		render: value => <Box sx={{ display: "flex" }}>
			<Typography variant="subtitle1">
				{value}
			</Typography>
		</Box>,
	}
}